export enum ComplexCatalogsNamesEnum {
  KNM_REASON_TYPES = 'KNM_REASON_TYPES',
  KNM_REJECT_REASON_TYPES = 'KNM_REJECT_REASON_TYPES',
  KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE = 'KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE',
  ERKNM_KNM_REJECT_REASON_TYPES = 'ERKNM_KNM_REJECT_REASON_TYPES',
  ERKNM_KNM_CONDITIONS = 'ERKNM_KNM_CONDITIONS',
  ORDERS_RELATION_DICTIONARIES = 'ORDERS_RELATION_DICTIONARIES',
  KNM_TYPES_248 = 'KNM_TYPES_248',
  KNO_ORGANIZATIONS = 'KNO_ORGANIZATIONS',
  FNS_REGISTRY_OKVED_CODES = 'FNS_REGISTRY_OKVED_CODES',
}
